/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
// import axios from 'axios';
import $http from '../../plugins/axios';
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const invokeseedMaster = async (url: string) => {
  let res;
  // eslint-disable-next-line camelcase
  await $http.get(url).then((response) => {
    res = response.data;
    return res;
  });
  return res;
};

export const invokeSkillSync = async (url: string) => {
  let res;
  // eslint-disable-next-line camelcase
  await $http.get(url).then((response) => {
    res = response.data;
    return res;
  });
  return res;
};
export const invokeTemplateSeed = async (url: string) => {
  let res;
  await $http.get(url).then((response) => {
    res = response.data;
    return res;
  });
  return res;
};
export const invokeCacheSync = async (url: string) => {
  let res;
  // eslint-disable-next-line camelcase
  await $http.get(url).then((response) => {
    res = response.data;
    return res;
  });
  return res;
};
export const invokeseedDefaultProgram = async (url: string) => {
  let res;
  // eslint-disable-next-line camelcase
  await $http.get(url).then((response) => {
    res = response.data;
    return res;
  });
  return res;
};
export const invokeseedRoles = async (url: string) => {
  let res;
  // eslint-disable-next-line camelcase
  await $http.get(url).then((response) => {
    res = response.data;
    return res;
  });
  return res;
};
export const invokeSeedProxyReviewers = async (url: string) => {
  let res;
  // eslint-disable-next-line camelcase
  await $http.get(url).then((response) => {
    res = response.data;
    return res;
  });
  return res;
};
export const invokeSeedUser = async (url: string) => {
  let res;
  await $http.get(url).then((response) => {
    res = response.data;
    return res;
  });
  return res;
};
export const invokeDiffAccess = async (url: string) => {
  let res;
  await $http.get(url).then((response) => {
    res = response.data;
    return res;
  });
  return res;
};
export const invokemigrateCohort = async (url: string) => {
  let res;
  await $http.get(url).then((response) => {
    res = response.data;
    return res;
  });
  return res;
};
export const invokeMigrateCohortLA = async (url: string) => {
  let res;
  await $http.get(url).then((response) => {
    res = response.data;
    return res;
  });
  return res;
};
export const invokeMigrateCohortReview = async (url: string) => {
  let res;
  await $http.get(url).then((response) => {
    res = response.data;
    return res;
  });
  return res;
};
export const invokeS2TasksMigration = async (url: string) => {
  let res;
  await $http.get(url).then((response) => {
    res = response.data.userObj;
    return res;
  });
  return res;
};
export const invokeS2LAImport = async (url: string) => {
  let res;
  await $http.get(url).then((response) => {
    res = response.data.userObj;
    return res;
  });
  return res;
};
export const invokeS2LAMigration = async (url: string) => {
  let res;
  await $http.get(url).then((response) => {
    res = response.data.userObj;
    return res;
  });
  return res;
};
export const invokeMigrateS3Task = async (url: string) => {
  let res;
  await $http.get(url).then((response) => {
    res = response.data;
    return res;
  });
  return res;
};
export const invokeMigrateS3LA = async (url: string) => {
  let res;
  await $http.get(url).then((response) => {
    res = response.data;
    return res;
  });
  return res;
};
export const invokeMigrateS3Review = async (url: string) => {
  let res;
  await $http.get(url).then((response) => {
    res = response.data;
    return res;
  });
  return res;
};
export const removeDuplicateProxyLearner = async (url: string) => {
  const res = await $http.get(url);
  return res;
};
export const updateS3CohortsLearnerModifiedDate = async (url: string) => {
  const res = await $http.get(url);
  return res;
};
export const invokeofcon = async (url: string) => {
  const res = await $http.get(url);
  return res;
};
// export const invokeMasterSeed = async (url: string) => {
//   let res;
//   // eslint-disable-next-line camelcase
//   await $http.get(`${url}}`).then((response) => {
//     res = response.data;
//     return res;
//   });
//   return res;
// };

export const invokeProxyReviewSeed = async (url: string) => {
  let res;
  await $http.get(url).then((response) => {
    res = response.data;
    return res;
  });
  return res;
};

export const invokeMigrateCohortProgram = async (url: string) => {
  let res;
  await $http.get(url).then((response) => {
    res = response.data;
    return res;
  });
  return res;
};

export const invokeGetUserRole = async (url: string) => {
  let res;
  await $http.get(url).then((response) => {
    res = response.data.userObj;
    return res;
  });
  return res;
};

export const assignRoleToUser = async (data: any) => {
  const res = await $http.post('/user/role', data);
  return res;
};

export const removeRoleFromUser = async (data: any) => {
  const res = await $http.post('/user/removeRole', data);
  return res;
};

export const getAllRoles = async () => {
  const res = await $http.get('role');
  return res;
};
export const importLSS = async (key: any) => {
  const res = await $http.post('/user/saveLSS', key);
  return res;
};
export const importEnvaccess = async (key: any) => {
  const res = await $http.post('/user/saveEnvAccess', key);
  return res;
};
